import 'react-app-polyfill/ie9'
import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import React, { Suspense } from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter as Router } from 'react-router-dom'
import { MsalProvider } from '@azure/msal-react'
import { Configuration, PublicClientApplication } from '@azure/msal-browser'

import { datadogRum } from '@datadog/browser-rum'
import { reactPlugin } from '@datadog/browser-rum-react'
import { AppContextProvider } from './store/context'
import App from './App'
import IEisNotAllowed from './pages/IEisNotAllowed'
import * as serviceWorker from './serviceWorker'

import './assets/sass/main.scss'

const isDatadogEnabled = Boolean(
  parseInt(process?.env?.REACT_APP_DATADOG_ACTIVATION || '0', 10)
)

if (isDatadogEnabled) {
  datadogRum.init({
    applicationId: process.env.REACT_APP_DATADOG_APPLICATION_ID,
    clientToken: process.env.REACT_APP_DATADOG_CLIENT_TOKEN,
    site: 'datadoghq.eu',
    service: process.env.REACT_APP_DATADOG_SERVICE_NAME,
    env: process.env.REACT_APP_ENVIRONMENT,
    allowedTracingOrigins: process.env.REACT_APP_DATADOG_ALLOWED_TRACING_URLS,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    defaultPrivacyLevel: 'mask',
    plugins: [reactPlugin({ router: true })],
    transport: 'beacon',
  })

  datadogRum.startView()
}

// MSAL configuration
const configuration: Configuration = {
  auth: {
    clientId: `${process.env.REACT_APP_AZURE_AD_CLIENT_ID}`,
    authority: `${process.env.REACT_APP_AZURE_AD_URL_AUTH}`,
    redirectUri: `${process.env.REACT_APP_AZURE_AD_REDIRECT_URI}`,
  },
}

const pca = new PublicClientApplication(configuration)

const AppInput = () => {
  // @ts-ignore
  const isIE = window.document.documentMode
  if (isIE) {
    return (
      <Suspense fallback={<>...</>}>
        <IEisNotAllowed />
      </Suspense>
    )
  }
  return (
    <AppContextProvider>
      <div className="app">
        <Router>
          <MsalProvider instance={pca}>
            <App />
          </MsalProvider>
        </Router>
      </div>
    </AppContextProvider>
  )
}

ReactDOM.render(<AppInput />, document.getElementById('root'))

serviceWorker.unregister()
